<ion-header>
  <ion-toolbar class="thin-toolbar background-background" mode="ios">
    <frontend-header routeId="togo"></frontend-header>
  </ion-toolbar>
</ion-header>

<ion-content [forceOverscroll]="false">
  <frontend-pull-refresh></frontend-pull-refresh>

  <section>
    <div class="search-row">
      <tablesready-search-bar #searchBarRef placeholder="Search" (search)="search($event, togoTable)"></tablesready-search-bar>
    </div>

    <tablesready-shared-table
      #togoTable
      [columns]="columns"
      [dataSource]="dataSource"
      [enablePagination]="false"
      [showHeader]="!isMobile"
      [customRowClass]="isMobile ? 'shared-table¬mobile-row' : null"
      [customCellClass]="isMobile ? 'shared-table¬mobile-cell' : null"
      (dataLoaded)="dataLoaded()"
    >
    </tablesready-shared-table>

    <p *ngIf="dataSource.total === 0" class="p-3">No upcoming to go requests.</p>
  </section>

  <ion-infinite-scroll (ionInfinite)="onIonInfinite($event, togoTable)">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>

  <div class="add-new">
    <span class="add-new-blocker" slot="fixed">
      <button type="button"
              class="btn btn-accent btn-circle"
              (click)="addEditParty()"
              id="addEditParty-button"
      >
        <tr-icon [icon]="icon.plus" [size]="iconSize.large" [color]="iconColor.white"></tr-icon>
      </button>
    </span>
  </div>

  <ng-template #nameColumn let-item="item">
    <p>
      <span class="lead name">{{ item?.name }}</span>&nbsp;
      <tablesready-party-badge
        [party]="item"
        [showTypeBadge]="false"
      ></tablesready-party-badge>
    </p>
    <p
      *ngIf="item?.phone"
      [innerText]="item?.phone | trTel:user?.location?.country:'custom'"
      data-dd-privacy="mask"
    ></p>
  </ng-template>

  <ng-template #actionsColumn let-item="item" let-index="index">
    <tablesready-waitlist-actions
      [togoMode]="true"
      [isUserOnFreePlan]="isUserOnFreePlan"
      [party]="item"
      [index]="index"
      [callbacks]="actionsCallbacks"
      [isMobile]="isHandset"
    ></tablesready-waitlist-actions>
  </ng-template>

  <ng-template #quotedTimeColumn let-item="item">
    <tablesready-waitlist-quoted-time
      [party]="item"
      [label]="user.location?.displayOptions?.labels?.quoted"
      [timezone]="user.location.timezone">
    </tablesready-waitlist-quoted-time>
  </ng-template>

  <ng-template #waitColumn let-item="item">
    <span class="d-xs-inline d-sm-none">Wait: </span>
    {{ ((item?.checkin_time || item?.created_time) ? (now - (item?.checkin_time || item?.created_time)) : 0) | trTimeDelta }}
  </ng-template>

  <ng-template #notifyColumn let-item="item" let-index="index">
    <tablesready-waitlist-notify
      [togoMode]="true"
      [party]="item"
      [notificationTime]="user.location.displayOptions.notificationTime"
      [voicePageNotificationEnabled]="user.location.messages.voicePageNotification.enabled"
      [timezone]="user.location.timezone"
      [index]="index"
      [notifyActions]="notifyActions"
      [isMobile]="isHandset"
    >
    </tablesready-waitlist-notify>
  </ng-template>
</ion-content>
